import { useState } from "react";
import Loader from "../../../utils/loader/Loader";

function RCIProfessionalPopup({
  visible,
  onClose,
  getTranslateText,
  setSelectedUserType,
  handleChange,
}) {
  const [loading, setLoading] = useState(false);
  if (!visible) return null;

  const getTextByKey = (key, fallback) => {
    const item = getTranslateText?.data?.find((item) => item.pageKey === key);
    return item?.keyValue || fallback;
  };

  const onClickYes = async () => {
    setLoading(true);
    setSelectedUserType(12);
    onClose();
    const staticEvent = {
      target: { id: 12, value: 12, name: "userType" },
    };
    handleChange(staticEvent, "userType");
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      {loading ? (
        <div className="flex justify-center items-center h-[80%]">
          <Loader type="spinningBubbles" color="#2e376c" />
        </div>
      ) : (
        <div className="w-full md:w-[450px] m-auto rounded-[30px] bg-white">
          <div className="px-6 py-[40px] flex flex-col justify-center items-center">
            <h5 className="font-semibold md:text-[22px] text-[20px] text-[#101942]">
              {getTextByKey("switch_profile", "Switch Profile")}
            </h5>
            <p className="w-[80%] text-[#6D7289] font-light text-[14px] text-center py-4">
              {getTextByKey(
                "switch_profile_des",
                "Do you want to continue with Special Educator or Continue with CRE Programme?"
              )}
            </p>
            <div className="flex justify-around w-[100%]">
              <button
                onClick={onClose}
                className="bg-gradient-to-r from-[#E7EAFF] to-[#E7EAFF] text-[#3C57AD] px-[50px] py-[10px] rounded-[10px] mt-[20px]  w-[40%] text-center flex flex-row justify-center"
              >
                {getTextByKey("alert_no", "No")}
              </button>
              <button
                className="bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-[#fff] px-[50px] py-[10px] rounded-[10px] mt-[20px] w-[40%] text-center flex flex-row justify-center"
                onClick={() => onClickYes()}
              >
                {getTextByKey("alert_yes", "Yes")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RCIProfessionalPopup;
